import { SOUND_CREATOR_V2_ABI, SOUND_CREATOR_V2_ADDRESS } from '../../abi/sound-creator-v2.mjs';
import { SOUND_EDITION_V2_IMPLEMENTATION_ADDRESS } from '../../abi/sound-edition-v2.mjs';
import { getSaltAsBytes32 } from '../../utils/helpers.mjs';

async function getExpectedEditionAddress(client, { deployer, salt: customSalt }) {
  const formattedSalt = getSaltAsBytes32(customSalt || Math.random() * 1e15);
  const [edition, exists] = await client.readContract({
    abi: SOUND_CREATOR_V2_ABI,
    address: SOUND_CREATOR_V2_ADDRESS,
    functionName: "soundEditionAddress",
    args: [SOUND_EDITION_V2_IMPLEMENTATION_ADDRESS, deployer, formattedSalt]
  });
  return {
    formattedSalt,
    edition,
    exists
  };
}

export { getExpectedEditionAddress };
